import ShowPassword from "@mui/icons-material/Visibility";
import HidePassword from "@mui/icons-material/VisibilityOff";
import {IconButton, InputAdornment, TextField} from "@mui/material";
import type {FormField} from "hooks/useForm";
import {type FC, useState} from "react";

const PasswordInput: FC<FormField<string>> = props => {
  const {onChange, error, value, label, onBlur} = props;

  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      label={label}
      type={showPassword ? "text" : "password"}
      value={value}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
      error={!!error}
      helperText={error}
      fullWidth
      margin="normal"
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword(prev => !prev)}
                edge="end"
                aria-label={showPassword ? "Hide password" : "Show password"}>
                {showPassword ? <HidePassword /> : <ShowPassword />}
              </IconButton>
            </InputAdornment>
          ),
        },
        formHelperText: {
          sx: {marginLeft: 0},
        },
      }}
    />
  );
};

export default PasswordInput;
